function parseVersionParts(version) {
  if (version == null) return null;
  const raw = String(version).trim();
  if (!raw) return null;
  const parts = raw.split('.').map((p) => {
    const n = parseInt(p.replace(/[^0-9].*$/, ''), 10);
    return Number.isFinite(n) ? n : 0;
  });
  return parts.length ? parts : null;
}

/**
 * @returns {boolean} true when remote is strictly newer than current
 */
export function isRemoteVersionNewer(remote, current) {
  const remoteParts = parseVersionParts(remote);
  const currentParts = parseVersionParts(current);
  if (!remoteParts || !currentParts) return false;

  const len = Math.max(remoteParts.length, currentParts.length);
  for (let i = 0; i < len; i += 1) {
    const r = remoteParts[i] ?? 0;
    const c = currentParts[i] ?? 0;
    if (r > c) return true;
    if (r < c) return false;
  }
  return false;
}
